import { gql } from '@apollo/client'
import { ALL_PRIORITIES_COMPLIANCE_FRAGMENT } from '../fragments/AllPrioritiesComplianceFragment'

export const PICOS_ALL_PRIORITIES_COMPLIANCE = gql`
  query PicOSAllPrioritiesCompliance(
    $input: PicOSAllPrioritiesComplianceInput!
  ) {
    picosAllPrioritiesCompliance(input: $input) {
      hasMore
      count
      results {
        ...AllPrioritiesCompliance
      }
    }
  }
  ${ALL_PRIORITIES_COMPLIANCE_FRAGMENT}
`
